import React, { Component } from 'react';

class Waves extends Component {

	dots = 80;
	delay = 60;
	type = 0;
	maxSpeed = 0;
	minSpeed = 100;
	ratio = 1;
	tension = 1;
	lineWidth = 2;
	downloadColor = 'rgba(234, 135, 46, 0.5)';
	uploadColor = 'rgba(217, 40, 40, 0.5)';
	downloadHistory = [];
	uploadHistory = [];

	constructor(props) {
		super(props);

		this.state = {
			running: props.running
		};
	}

	componentDidMount() {
		window.addEventListener('resize', () => this.setDimensions());
	}

	componentWillUnmount() {
		window.removeEventListener('resize', () => this.setDimensions());
	}

	componentDidUpdate() {
		if (!this.state.running && this.props.running) {
			this.downloadHistory = [];
			this.uploadHistory = [];
			this.type = 0;
			this.maxSpeed = 0;
			this.minSpeed = 100;

			this.setState({
				running: true,
			});

			this.timer = setTimeout(this.tick, this.delay);
		}

		if (this.state.running && !this.props.running) {
			this.setState({
				running: false,
			});
		}

		if (!this.state.running) {
			this.setDimensions();
		}
	}

	tick = () => {
		if (this.refs.canvas.width === 0 && this.refs.canvas.height === 0 && this.refs.canvas.offsetWidth > 0 && this.refs.canvas.offsetHeight > 0)
			this.setDimensions();

		this.calculate();
		this.draw();

		if (this.state.running)
			this.timer = setTimeout(this.tick, this.delay);
	}

	setDimensions() {
		let ctx = document.createElement("canvas").getContext("2d"),
			dpr = window.devicePixelRatio || 1,
			bsr = ctx.webkitBackingStorePixelRatio ||
				ctx.mozBackingStorePixelRatio ||
				ctx.msBackingStorePixelRatio ||
				ctx.oBackingStorePixelRatio ||
				ctx.backingStorePixelRatio || 1;

		this.ratio = dpr / bsr;

		this.refs.canvas.width  = this.refs.canvas.offsetWidth * this.ratio;
		this.refs.canvas.height = this.refs.canvas.offsetHeight * this.ratio;
        this.refs.canvas.getContext("2d").setTransform(this.ratio, 0, 0, this.ratio, 0, 0);
	}

	calculate() {
		if (!this.props.download && this.type === 0)
			this.type = 1;

		if (this.props.speed > 0 && this.props.speed >= this.maxSpeed) {
			this.maxSpeed = 5 * Math.ceil(this.props.speed/5);
		}
		if (this.props.speed > 0 && this.props.speed <= this.minSpeed) {
			this.minSpeed = 5 * Math.floor(this.props.speed/5);
		}

		var speedPercent = (this.props.speed - this.minSpeed)/(this.maxSpeed - this.minSpeed);
		var speedVal = this.refs.canvas.height/(4*this.ratio) - this.refs.canvas.height/(4*this.ratio)*speedPercent;
		speedVal = speedVal < this.lineWidth ? this.lineWidth : speedVal;

//		console.log("speed", this.props.speed);
//		console.log("speedPercent", speedPercent, this.minSpeed, this.maxSpeed);
//		console.log("speedVal", speedVal);

		if (speedPercent > 0 && this.maxSpeed > 0) {
			if (this.type === 0) {
				var newDownloadHistory = [];

				if (this.downloadHistory.length < this.dots) {
					for (var di = 0; di < this.dots; di++) {
						newDownloadHistory.push([di * this.refs.canvas.offsetWidth / this.dots, speedVal]);
					}
				} else {
					for (var dj = 1; dj < this.dots; dj++) {
						newDownloadHistory.push([(dj - 1) * this.refs.canvas.offsetWidth / this.dots, this.downloadHistory[dj][1]]);
					}
					newDownloadHistory.push([this.refs.canvas.offsetWidth, speedVal]);
				}

				this.downloadHistory = newDownloadHistory;
			} else {
				var newUploadHistory = [];

				if (this.uploadHistory.length < this.dots) {
					for (var ui = 0; ui < this.dots; ui++) {
						newUploadHistory.push([ui * this.refs.canvas.offsetWidth / this.dots, speedVal]);
					}
				} else {
					for (var uj = 1; uj < this.dots; uj++) {
						newUploadHistory.push([(uj - 1) * this.refs.canvas.offsetWidth / this.dots, this.uploadHistory[uj][1]]);
					}
					newUploadHistory.push([this.refs.canvas.offsetWidth, speedVal]);
				}

				this.uploadHistory = newUploadHistory;
			}
		}
	}

	draw() {
		const ctx = this.refs.canvas.getContext('2d');

		ctx.clearRect(0, 0, this.refs.canvas.width, this.refs.canvas.height);

		ctx.lineWidth = this.lineWidth;
		ctx.lineCap = "round";

		// Background download
		if (this.downloadHistory[0]) {
			var grd = ctx.createLinearGradient(0, 0, 0, this.refs.canvas.height);
			grd.addColorStop(0, 'rgba(234, 135, 46, 0.1)');
			grd.addColorStop(1, 'rgba(238, 242, 244, 0.1)');
			ctx.fillStyle = grd;
			ctx.strokeStyle = this.downloadColor;

			ctx.beginPath();
			ctx.moveTo(0, this.refs.canvas.height - this.lineWidth/2);
			ctx.lineTo(0, this.downloadHistory[0][1]);
			for (var i = 0; i < this.downloadHistory.length - 1; i++) {
				var p0 = (i > 0) ? this.downloadHistory[i - 1] : this.downloadHistory[0];
				var p1 = this.downloadHistory[i];
				var p2 = this.downloadHistory[i + 1];
				var p3 = (i !== this.downloadHistory.length - 2) ? this.downloadHistory[i + 2] : p2;

				var cp1x = p1[0] + (p2[0] - p0[0]) / 6 * this.tension;
				var cp1y = p1[1] + (p2[1] - p0[1]) / 6 * this.tension;
				var cp2x = p2[0] - (p3[0] - p1[0]) / 6 * this.tension;
				var cp2y = p2[1] - (p3[1] - p1[1]) / 6 * this.tension;

				ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2[0], p2[1]);
			}
			if (this.downloadHistory.length > 0) {
				ctx.lineTo(this.downloadHistory[this.downloadHistory.length-1][0] + this.lineWidth/2, this.refs.canvas.height);
				ctx.fill();
			}

			// Line download
			ctx.beginPath();
			ctx.moveTo(0, this.downloadHistory[0][1]);
			for (i = 0; i < this.downloadHistory.length - 1; i++) {
				p0 = (i > 0) ? this.downloadHistory[i - 1] : this.downloadHistory[0];
				p1 = this.downloadHistory[i];
				p2 = this.downloadHistory[i + 1];
				p3 = (i !== this.downloadHistory.length - 2) ? this.downloadHistory[i + 2] : p2;

				cp1x = p1[0] + (p2[0] - p0[0]) / 6 * this.tension;
				cp1y = p1[1] + (p2[1] - p0[1]) / 6 * this.tension;
				cp2x = p2[0] - (p3[0] - p1[0]) / 6 * this.tension;
				cp2y = p2[1] - (p3[1] - p1[1]) / 6 * this.tension;

				ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2[0], p2[1]);
			}
			ctx.stroke();
		}

		// Background upload
		if (this.uploadHistory[0]) {
			grd = ctx.createLinearGradient(0, 0, 0, this.refs.canvas.height);
			grd.addColorStop(0, 'rgba(217, 40, 40, 0.1)');
			grd.addColorStop(1, 'rgba(238, 242, 244, 0.1)');
			ctx.fillStyle = grd;
			ctx.strokeStyle = this.uploadColor;


			ctx.beginPath();
			ctx.moveTo(0, this.refs.canvas.height - this.lineWidth/2);
			ctx.lineTo(0, this.uploadHistory[0][1]);
			for (i = 0; i < this.uploadHistory.length - 1; i++) {
				p0 = (i > 0) ? this.uploadHistory[i - 1] : this.uploadHistory[0];
				p1 = this.uploadHistory[i];
				p2 = this.uploadHistory[i + 1];
				p3 = (i !== this.uploadHistory.length - 2) ? this.uploadHistory[i + 2] : p2;

				cp1x = p1[0] + (p2[0] - p0[0]) / 6 * this.tension;
				cp1y = p1[1] + (p2[1] - p0[1]) / 6 * this.tension;
				cp2x = p2[0] - (p3[0] - p1[0]) / 6 * this.tension;
				cp2y = p2[1] - (p3[1] - p1[1]) / 6 * this.tension;

				ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2[0], p2[1]);
			}
			if (this.uploadHistory.length > 0) {
				ctx.lineTo(this.uploadHistory[this.uploadHistory.length-1][0] + this.lineWidth/2, this.refs.canvas.height);
				ctx.fill();
			}

			// Line upload
			ctx.beginPath();
			ctx.moveTo(0, this.uploadHistory[0][1]);
			for (i = 0; i < this.uploadHistory.length - 1; i++) {
				p0 = (i > 0) ? this.uploadHistory[i - 1] : this.uploadHistory[0];
				p1 = this.uploadHistory[i];
				p2 = this.uploadHistory[i + 1];
				p3 = (i !== this.uploadHistory.length - 2) ? this.uploadHistory[i + 2] : p2;

				cp1x = p1[0] + (p2[0] - p0[0]) / 6 * this.tension;
				cp1y = p1[1] + (p2[1] - p0[1]) / 6 * this.tension;
				cp2x = p2[0] - (p3[0] - p1[0]) / 6 * this.tension;
				cp2y = p2[1] - (p3[1] - p1[1]) / 6 * this.tension;

				ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2[0], p2[1]);
			}
			ctx.stroke();
		}
	}

	render() {
		return (
			<canvas ref="canvas" style={{width: "100%", height: "100%"}}>Этот элемент не поддерживается</canvas>
		);
	}
}

export default Waves;
